import { useCallback, useState } from "react";

export function useToast() {
  const [toast, setToast] = useState(null);
  const showToast = useCallback((text) => setToast({ text, id: Date.now() }), []);
  return { toast, showToast };
}
